module.exports = __webpack_public_path__ + "static/media/206-Telefonat_ID_26.34aab2d5.mp3";